export default "/images/vendor/leaflet-fullscreen/dist/fullscreen@2x.png?29e76bbe73634d791d3c2108f0b66dd0";